<template>
  <div class="row">
    <div class="col-sm-6">
      <card class="stacked-form">
        <form @submit.prevent="submit">
          <!-- <fg-input label="Bestellungen Absender E-Mail Adresse" type="email" v-model="orderEmail" /> -->
          <fg-input label="Bestell E-Mail Betreff" type="textarea" v-model="emailSubject" />

          <div>
            <label>E-Mail Standardtext | Kopfzeile allgemein</label>
            <div class="form-group has-label">
              <textarea class="form-control" v-model="orderEmailDefaultText" rows="3"></textarea>
            </div>
          </div>

          <div>
            <label>Bestell E-Mail Standardzusatztext für neue Lieferanten</label>
            <div class="form-group has-label">
              <textarea class="form-control" v-model="orderEmailSupplierText" rows="3"></textarea>
            </div>
          </div>

          <div>
            <label>Bestell E-Mail Standardzusatztext für neue Läger</label>
            <div class="form-group has-label">
              <textarea class="form-control" v-model="orderEmailWarehouseText" rows="3"></textarea>
            </div>
          </div>
          <div>
            <label>Bestell E-Mail Produkttext</label>
            <div class="form-group has-label">
              <textarea class="form-control" v-model="orderEmailProductText" rows="3"></textarea>
            </div>
          </div>
          <div>
            <label>Bestell E-Mail Signatur</label>
            <div class="form-group has-label">
              <textarea class="form-control" v-model="orderEmailEndText" rows="3"></textarea>
            </div>
          </div>
          <div>
            <label>Standardtext für Lager</label>
            <div class="form-group has-label">
              <textarea class="form-control" v-model="warehouseDefaultText" rows="3"></textarea>
            </div>
          </div>

          <div>
            <label>Sammelbuchungen Bearbeitungszeit (Stunden)</label>
            <div class="form-group has-label">
              <input
                type="number"
                class="form-control"
                v-model.number="collectiveBookingEditHours"
                min="1"
                placeholder="24" />
            </div>
          </div>
          <div>
            <label>Mehrwertsteuersätze</label>
            <div class="">
              <div class="row row-cols-md-3 g-3">
                <div v-for="(tax, index) in taxes" :key="index" class="col">
                  <div class=" row row-cols-2 rounded p-3 position-relative">
                    <div  style="padding-right: 2px;">
                      <label class="form-label">Label</label>
                      <input type="text" class="form-control border-secondary mb-2" v-model="tax.label">
                    </div>

                    <div>
                      <label class="form-label" style="width: 100%;">Steuersatz (%)</label>
                      <input type="text" class="form-control border-secondary mb-2" @change="handleTaxValueInput(index, $event.target.value)"
                        :value="formatTaxValueForDisplay(tax.value)" @blur="updateTaxValue(index, $event.target.value)">
                    </div>

                    <button style="top:10px; right:10px;  border-radius:50%; padding:3px; " type="button"
                      class="btn btn-danger btn-sm position-absolute" @click="removeTax(index)">
                      <i class="fa fa-minus"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div style="text-align:right;">
              <div class="btn btn-primary" style="cursor: pointer;  padding: 5px;" @click="addTax"> <i
                  class="fa fa-plus"></i></div>
            </div>
          </div>

          <button type="submit" class="btn btn-fill btn-info">Speichern</button>
        </form>
      </card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      orderEmail: '',
      emailSubject: '',
      orderEmailDefaultText: '',
      orderEmailSupplierText: '',
      orderEmailWarehouseText: '',
      orderEmailProductText: '',
      orderEmailEndText: '',
      taxes: [],
      warehouseDefaultText: '',
      collectiveBookingEditHours: 24,
    }
  },
  methods: {
    async submit() {
      await this.initCsrf()

      this.$http.put('/settings', {
        order_email: this.orderEmail,
        email_subject: this.emailSubject,
        order_email_default_text: this.orderEmailDefaultText,
        order_email_supplier_text: this.orderEmailSupplierText,
        order_email_warehouse_text: this.orderEmailWarehouseText,
        order_email_product_text: this.orderEmailProductText,
        order_email_end_text: this.orderEmailEndText,
        taxes: this.taxes,
        warehouse_default_text: this.warehouseDefaultText,
        collective_booking_edit_hours: this.collectiveBookingEditHours,
      }).then(() => {
        this.$notify({
          message: 'Allgemeine Einstellungen erfolgreich gespeichert.',
          type: 'success'
        })
      })
    },
    addTax() {
      this.taxes.push({ label: "", value: "" });
    },
    removeTax(index) {
      this.taxes.splice(index, 1);
    },
    handleTaxValueInput(index, value) {
      let inputValue = value

      inputValue = inputValue.replace(/[^0-9.,]/g, '');

      inputValue = inputValue.replace(/,/g, '.');


      const numericValue = parseFloat(inputValue) || 0;
      const decimalValue = (numericValue / 100).toFixed(3);

      this.taxes[index].value = decimalValue;
    },
    formatTaxValueForDisplay(decimalValue) {
      if (!decimalValue) return '';
      const percentage = (parseFloat(decimalValue) * 100).toFixed(1);
      return percentage.replace('.', ',');
    },
    updateTaxValue(index, displayValue) {
      let value = displayValue.replace(/[^0-9.,]/g, '');
      value = value.replace(/,/g, '.');
      const numericValue = parseFloat(value) || 0;
      const decimalValue = (numericValue / 100).toFixed(3);
      this.taxes[index].value = decimalValue;
    }
  },
  created() {
    this.$http.get('/settings').then(({ data }) => {
      this.orderEmail = data.order_email
      this.emailSubject = data.email_subject
      this.orderEmailDefaultText = data.order_email_default_text
      this.orderEmailSupplierText = data.order_email_supplier_text
      this.orderEmailWarehouseText = data.order_email_warehouse_text
      this.orderEmailProductText = data.order_email_product_text
      this.orderEmailEndText = data.order_email_end_text
      this.taxes = JSON.parse(data.taxes) || []
      this.signature = data.signature
      this.warehouseDefaultText = data.warehouse_default_text
      this.collectiveBookingEditHours = data.collective_booking_edit_hours || 24
    })
    this.$http.get('/auth/user').then(({ data }) => {
      this.signature = data.signature
      this.use_sig_to_all = data.use_sig_to_all === 1 ? true : false
      this.user = data;
    })
  }
}
</script>

<style></style>
